import React, { useEffect } from 'react';
import { MetaPixel } from './components/MetaPixel';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { InsidePreview } from './components/InsidePreview';
import { PainSection } from './components/PainSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { ValueStack } from './components/ValueStack';
import { GradeLevelsSection } from './components/GradeLevelsSection';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { ClosingBlock } from './components/ClosingBlock';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FloatingCTA } from './components/FloatingCTA';
interface AppProps {
  showPurchaseNotifications?: boolean;
}
export function App({
  showPurchaseNotifications = true
}: AppProps) {
  useEffect(() => {
    document.title = 'THE COMPLETE ART YEAR™';
  }, []);
  return <div className="w-full bg-navy text-white" data-id="element-0" data-mp="3rcj8i7wbs999">
      <MetaPixel data-id="element-1" data-mp="3rcswxr1q28cu" />
      <StickyHeader data-id="element-2" data-mp="3reccfffk0fdk" />
      <main data-id="element-3" data-mp="5ygolyg4xb6">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-4" data-mp="6hp9c27i9cj" />
        <Hero data-id="element-5" data-mp="56qxrrj5tst" />
        <SocialProofBar data-id="element-6" data-mp="7stfczkdj46" />
        <InsidePreview data-id="element-7" data-mp="2zllen0i82im7" />
        <PainSection data-id="element-8" data-mp="2zm4vedw4z0yn" />
        <VolumesSection data-id="element-9" data-mp="2zmwit1fkxsdu" />
        <BonusesSection data-id="element-10" data-mp="33mouhn09senf" />
        <ValueStack data-id="element-11" data-mp="33m5bs42spm8c" />
        <GradeLevelsSection data-id="element-12" data-mp="33nges1of2pye" />
        <Testimonials data-id="element-13" data-mp="33orhrza1ftog" />
        <Guarantee data-id="element-14" data-mp="38lrpeemjd4ho" />
        <ClosingBlock data-id="element-15" data-mp="38l8eviz7tido" />
        <FAQ data-id="element-16" data-mp="38l04pyuh8r66" />
      </main>
      <Footer data-id="element-17" data-mp="38nup5qdhqbzl" />
      <div className="h-[54px] md:hidden" aria-hidden="true" data-id="element-18" data-mp="38o4d78ez692n" />
      {showPurchaseNotifications && <SocialProofPopup data-id="element-19" data-mp="3dii4aymltu1i" />}
      <FloatingCTA data-id="element-20" data-mp="nw2ay2pqvkpi" />
    </div>;
}